import type { FieldType, Question } from '../../../../shared/types';

import { LinkQuestionField } from './components/LinkQuestionField';
import { OptionsQuestionField } from './components/OptionsQuestionField';
import { TextQuestionField } from './components/TextQuestionField';

type Props = {
	parent: FieldType;
	question: Question;
	idx: number;
};

export const BaseQuestionField: React.FC<Props> = ({ parent, question, idx }) => {
	switch (question.type) {
		case 'options':
			return <OptionsQuestionField parent={parent} question={question} idx={idx} />;
		case 'link':
			return <LinkQuestionField parent={parent} question={question} />;
		case 'text':
		default:
			return <TextQuestionField parent={parent} question={question} idx={idx} />;
	}
};
